export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    footerLogo: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    eligibilityFederalQuestion: string;
    eligibilityFederalAnswer: string;
    eligibilityCitizenQuestion: string;
    eligibilityCitizenAnswer: string;
    eligibilityAgeQuestion: string;
    eligibilityAgeAnswer: string;
    eligibilityOptInCommPrefQuestion: string;
    eligibilityOptInCommPrefAnswer: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    pathQuestion: string;
    pathPatientAnswer: string;
    pathProviderAnswer: string;
    careGiverQuestion: string;
    careGiverAnswer: string;
    careGiverHCPQuestion: string;
    careGiverHCPAnswer: string;
    careGiverZipQuestion: string;
    careGiverZipAnswer: string;
    eligibility_question_1: string;
    eligibility_question_2: string;
    eligibility_question_3: string;

    surveyIdHCP: string;
    HCPpathQuestion: string;
    HCPpathPatientAnswer: string;
    HCPpathHCPAnswer: string;
    hcp_eligibility_question_1: string;
    hcp_eligibility_question_2: string;
    hcp_eligibility_question_3: string;
    eligibilityHCPFederalQuestion: string;
    eligibilityHCPFederalYes: string;
    eligibilityHCPFederalNo: string;
    eligibilityHCPCitizenQuestion: string;
    eligibilityHCPCitizenYes: string;
    eligibilityHCPCitizenNo: string;
    eligibilityHCPAgeQuestion: string;
    eligibilityHCPAgeYes: string;
    eligibilityHCPAgeNo: string;

    eligibilityOptInCommPrefQuestionForHCP:string;
    eligibilityOptInCommPrefAnswerForHCP:string;
}
